import React, { useState, useEffect, useMemo, useRef, useContext, useCallback, memo, useReducer } from "react"
//import { useQuery } from "@tanstack/react-query";
//import { useReferentes } from "../context/ReferentesContext";
//import { ReferentesContext } from "../context/ReferentesContext";

//import { useDebugFormContext } from "../hooks/useDebugFormContext";

import { useFormContext } from "../context/FormContext";
import { NuevaONGContext } from "../context/NuevaONGContext";
import { GeoContext } from "../context/GeoContext";
import { useEstadoApp } from "../context/EstadoAppContext";

import { useNavigate } from 'react-router-dom';

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

//import { SocketContext } from "../context/socketContext";

import Select from "react-select";

import { Input, Label, Button, Select_simple } from "./ui"
import ListaContactosProyecto from './ListaContactosProyecto';
import DominioPdfUpload from './DominioPdfUpload';
import { parsearContactosObra, esObraConONG, normalizarTipoSubsidio } from '../utils/contactos';
//import { useAuth } from "../hooks/useAuth";
import { AuthContext } from "../context/authContext";
import { useTheme } from "../context/ThemeContext";
import { useGeo } from "../context/GeoContext";
import {
    optionsPartido, optionsTipoSubsidio, optionsEncargadoProyecto,
    optionsProgramaUNO, optionsProgramaDOS, optionsProgramaTRES, optionsProgramaCUATRO, optionsProgramaCINCO, optionsProgramaSEIS,
    optionsModalidadUNO, optionsModalidadDOS, optionsModalidadCUATRO,
    optionsTipoContratacion, optionsEstado, optionsTipoProyecto, optionsIdentificacionCatastral, optionsBarrioTipo,
    optionsAreaResponsable, optionsUniversidades
} from "../datos/options"

import { ESTADO_ANALISIS_PRELIMINAR, ESTADO_CONFECCION_EXPEDIENTE } from "../constants/config";

//Subformularios (nietos)
import TipoProyectoSubform from "./TipoProyectoSubform"; //formulario Tipo Proyecto y Subtipo
import ExpedienteSubform from "./ExpedienteSubform"; //formulario Expedientes (relacion uno a varios ---> guardar en tabla: obras_expediente )

//import Prueba from "./prueba";
import InputMontoObra from "./InputMontoObra"
import SubsidioForm from "./SubsidioForm";

import Modal2 from "./Modal2";
import InfoButtonWithPopover from "./InfoButtonWithPopover";
import { Modal } from "./ui/Modal";

import { adjustDateForTimezone } from '../utils/dateUtils';

import { AREA_RESP_OBRAS, AREA_RESP_MEJORAS, AREA_RESP_MICROCREDITOS, AREA_RESP_INTERVENCION_SOCIAL, AREA_RESP_CAPACITACIONES, AREA_RESP_OTRA } from "../constants/config";

// 2. CONSTANTES LOCALES (Fuera del componente para que no se re-creen al renderizar)
const PROGRAM_OPTIONS_MAP = {
    [AREA_RESP_OBRAS]: optionsProgramaUNO, // por ahora hardcodear
    [AREA_RESP_MEJORAS]: optionsProgramaDOS,
    [AREA_RESP_MICROCREDITOS]: optionsProgramaTRES,
    [AREA_RESP_INTERVENCION_SOCIAL]: optionsProgramaCUATRO,
    [AREA_RESP_CAPACITACIONES]: optionsProgramaSEIS,
    [AREA_RESP_OTRA]: optionsProgramaCINCO
};

//import io from "socket.io-client"; //13-ENE-25

//VER QUE SE RECUPERA ---> registro, setRegistro, estadoApp, formRows, setFormRows, editandoInput, setEditandoInput, setModoEdicion, socket, bloquear
//25JUL2025: onDataFromNieto se quito
/*const FormA = ({ estadoAppX, registro, onRegistroChange, onDataChangeSub, handleValidationChange, alSincronizar,
    handleLocalDataChange
 }) => {*/

const FormA = ({ estadoAppX }) => {

    // Usa el hook con una etiqueta para identificar los logs
    //const formAContext = useDebugFormContext('FormA');
    //donde uso formAContext?
    //console.log("FormAContext en formA", formAContext)
    console.log("estadoAppX en formA", estadoAppX)

    const {
        formA,
        updateField,
        validateForm
    } = useFormContext();

    // Obtener datos del formulario A
    const { datosGenerales = {} } = formA;

    const isSegundaEtapa = useMemo(() => datosGenerales.etapa === 2 || datosGenerales.tipo_microcredito === 'EXP_RENDIC', [datosGenerales?.etapa, datosGenerales?.tipo_microcredito]);

    const [_, forceUpdate] = useReducer(x => x + 1, 0);
    console.log("DATOS GENERALES en formA", datosGenerales)
    console.log("FORMA en formA", formA)

    const { isDarkMode } = useTheme();
    const { role, roles, user, token } = useContext(AuthContext);
    const { drawnFeatures } = useGeo();
    const { estadoAppX: estadoAppContext, cambiarEstadoApp } = useEstadoApp();
    const navigate = useNavigate();

    // --- Cambio de partido (crítico: recalcula el ID de la obra) ---
    // Solo visible/posible en estado 'Análisis preliminar' sobre una obra ya creada.
    const puedeCambiarPartido = useMemo(() =>
        Boolean(datosGenerales.id_partido_obra) &&
        String(datosGenerales.estado || '').trim().toLowerCase() === 'análisis preliminar' &&
        !isSegundaEtapa,
        [datosGenerales.id_partido_obra, datosGenerales.estado, isSegundaEtapa]
    );
    const partidoActualLabel = useMemo(() => {
        const opt = optionsPartido.find(o => String(o.value) === String(datosGenerales.partido ?? ''));
        return opt?.label || '';
    }, [datosGenerales.partido]);
    const [cambiarPartidoOpen, setCambiarPartidoOpen] = useState(false);
    const [cambiarPartidoTarget, setCambiarPartidoTarget] = useState('');
    const [cambiarPartidoLoading, setCambiarPartidoLoading] = useState(false);
    const [cambiarPartidoOk, setCambiarPartidoOk] = useState(false);
    const [cambiarPartidoMsg, setCambiarPartidoMsg] = useState(null); // {tipo: 'ok'|'error', texto}

    const abrirModalCambioPartido = () => {
        setCambiarPartidoTarget('');
        setCambiarPartidoMsg(null);
        setCambiarPartidoOk(false);
        setCambiarPartidoOpen(true);
    };

    const confirmarCambioPartido = async () => {
        if (!cambiarPartidoTarget || cambiarPartidoLoading || cambiarPartidoOk) return;
        setCambiarPartidoLoading(true);
        setCambiarPartidoMsg(null);
        try {
            const optPartido = optionsPartido.find(o => String(o.value) === String(cambiarPartidoTarget));
            const response = await fetch(`/api/obras/${datosGenerales.id_partido_obra}/cambiar-partido`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
                },
                body: JSON.stringify({
                    partido: Number(cambiarPartidoTarget),
                    partido_nombre: optPartido?.label || '',
                }),
            });
            const data = await response.json();
            if (!response.ok) {
                setCambiarPartidoMsg({ tipo: 'error', texto: data.error || data.message || `Error HTTP ${response.status}` });
                return;
            }
            const nuevoCodigo = data.nuevo?.cg_01_id_partido_obra;
            setCambiarPartidoMsg({
                tipo: 'ok',
                texto: `${data.message}. Se abrirá el proyecto migrado con su nuevo código ${nuevoCodigo || ''}.`,
            });
            setCambiarPartidoOk(true);
            setTimeout(() => {
                // Salir del original (borrado) y abrir directamente el proyecto nuevo
                setCambiarPartidoOpen(false);
                setCambiarPartidoOk(false);
                setCambiarPartidoMsg(null);
                localStorage.setItem('cambioPartidoNuevo', nuevoCodigo || '');
                localStorage.setItem('idPartidoObra', nuevoCodigo || '');
                localStorage.setItem('isEditingPagos', 'false');
                const nuevoEstado = estadoAppContext === 'edit_desde_proyectos' ? 'edit_desde_proyectos' : 'edit_desde_pagos';
                cambiarEstadoApp(nuevoEstado, { obra: nuevoCodigo, origen: 'inicio' });
                navigate(`/inicio?id_partido_obra=${encodeURIComponent(nuevoCodigo || '')}`, { replace: true });
            }, 2500);
        } catch (error) {
            console.error('Error al cambiar partido:', error);
            setCambiarPartidoMsg({ tipo: 'error', texto: 'Error de conexión al intentar cambiar el partido' });
        } finally {
            setCambiarPartidoLoading(false);
        }
    };

    // Verificar si el usuario puede ver la opción RENABAP (liberado para todos)
    const puedeVerRENABAP = true;

    // Filtrar opciones de tipo de barrio según permisos del usuario
    const optionsBarrioTipoFiltrado = puedeVerRENABAP
        ? optionsBarrioTipo
        : optionsBarrioTipo.filter(opt => opt.value !== 'RENABAP');

    // Filtrar opciones de estado: "Rescisión" habilitado solo para role=legal o admin
    const optionsEstadoFiltrado = optionsEstado.map(opt =>
        opt.value === 'Rescisión' && role !== 'legal' && role !== 'admin'
            ? { ...opt, disabled: true }
            : opt
    );

    // 1. Usamos useRef para rastrear si el componente está montado
    const isMounted = useRef(true);

    //console.log("REGISTRO en formA", registro)

    const { nuevaONG, ongsRefetch } = useContext(NuevaONGContext);
    //const { nuevoReferente } = useContext(ReferentesContext);

    //1- destructurar registro
    /*
    const {
        id_partido_obra,
        nombre_obra, //campo obligatorio
        fecha_carga,
        fecha_actualizacion: fechaActualizacionRaw, //renombramos registro.fecha_actualizacion a fechaActualizacionRaw
        encargado_proyecto,//responsable_interno, //campo obligatorio
        //presidente_ong, //09
        area_responsable, //nuevo 11-jun-2025 //campo obligatorio
        programa_lineamiento, //10
        modalidad, //10_1 ---> NUEVO 7-feb-25
        //referente_politico, //11 ---> se va por ahora 7-feb-25 //volvio 24-abril-2025 //se va nuevamente 26-may-25
        referente_politico_nombre,
        //contacto_proyecto, //12  ---> se va por ahora 7-feb-25
        beneficiarios, //13 si es numerico es NULL
        monto_obra, //14_1
        fecha_imputacion, //14_2
        tipo_contratacion, //15
        plazo_obra, //20
        estado, //16 
        //tipo_proyecto, //17 POR AHORA NO ---> iria a una tabla aparte (por Tipo)
        //categorias_items_obras, //18 ---> POR AHORA NO
        descripcion_proyecto, //19
        lc_21_localidad,//21 prueba
        lc_22_identificacion_catastral,
        lc_22_1_datos_catastrales,
        lc_22_2_cuadro_calles,
        lc_23_observaciones_localizacion,
        lc_24_titular_dominio,

        partido_nombre, //nuevo
        partido,//campo obligatorio
        array_obras_expediente, //---> igual que en la Base de datos
        array_tipo_subtipo_proyecto, // ---> igual que en la Base de datos
        barrio_tipo,
        barrio_rppvap_nombre,
        barrio_otro_nombre
    } = registro
    */
    //console.log("nombre_obra en REGISTRO ---> ", nombre_obra)

    const [formDataLocalizacion, setFormDataLocalizacion] = useState({ //para manejor ubicacion
        lc_21_localidad: '',
        lc_22_identificacion_catastral: '',
        lc_22_1_datos_catastrales: '',
        lc_22_2_cuadro_calles: '',
        lc_23_observaciones_localizacion: ''
    });

    const [modalIsOpen, setModalIsOpen] = useState(false);

    const [barriosRPPVAP, setBarriosRPPVAP] = useState([]); //estado para guardar los nombres de los barrios filtrados por partido
    const [barriosRENABAP, setBarriosRENABAP] = useState([]); //estado para guardar los barrios RENABAP filtrados por partido
    const barriosRPPVAPKeyRef = useRef(''); // prevenir re-fetch del mismo partido+tipos
    const barriosRENABAPKeyRef = useRef('');

    // Estados para selección múltiple de partidos - desde el contexto
    const { habilitarMultiplesPartidos = false, partidosSeleccionados = [] } = formA;

    // Estados para selección múltiple de barrios - desde el contexto
    const { barriosSeleccionados = [] } = formA;

    // Estados para selección múltiple de tipos de barrio y barrios RENABAP
    const { tiposBarrioSeleccionados = [], barriosRENABAPSeleccionados = [], barrioOtroNombres = [] } = formA;

    // Estilos personalizados para react-select (similar a Select_simple)
    const customSelectStyles = {
        control: (base, state) => ({
            ...base,
            minHeight: '40px',
            borderColor: state.isFocused ? '#3b82f6' : '#d1d5db',
            borderWidth: '1px',
            borderRadius: '0.375rem',
            boxShadow: state.isFocused ? '0 0 0 1px #3b82f6' : 'none',
            '&:hover': {
                borderColor: state.isFocused ? '#3b82f6' : '#9ca3af',
            },
            backgroundColor: document.documentElement.classList.contains('dark') ? '#1f2937' : '#ffffff',
        }),
        option: (base, state) => ({
            ...base,
            backgroundColor: state.isSelected
                ? '#3b82f6'
                : state.isFocused
                    ? '#e5e7eb'
                    : document.documentElement.classList.contains('dark') ? '#1f2937' : '#ffffff',
            color: state.isSelected
                ? '#ffffff'
                : document.documentElement.classList.contains('dark') ? '#ffffff' : '#111827',
            '&:hover': {
                backgroundColor: state.isSelected ? '#3b82f6' : '#e5e7eb',
            },
        }),
        menu: (base) => ({
            ...base,
            borderRadius: '0.375rem',
            border: '1px solid #d1d5db',
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
            backgroundColor: document.documentElement.classList.contains('dark') ? '#1f2937' : '#ffffff',
        }),
        multiValue: (base) => ({
            ...base,
            backgroundColor: '#dbeafe',
            borderRadius: '0.25rem',
        }),
        multiValueLabel: (base) => ({
            ...base,
            color: '#1e40af',
            fontSize: '0.875rem',
        }),
        multiValueRemove: (base) => ({
            ...base,
            color: '#1e40af',
            '&:hover': {
                backgroundColor: '#3b82f6',
                color: '#ffffff',
            },
        }),
        placeholder: (base) => ({
            ...base,
            color: '#9ca3af',
            fontSize: '0.875rem',
        }),
        input: (base) => ({
            ...base,
            color: document.documentElement.classList.contains('dark') ? '#ffffff' : '#111827',
            fontSize: '0.875rem',
        }),
        singleValue: (base) => ({
            ...base,
            color: document.documentElement.classList.contains('dark') ? '#ffffff' : '#111827',
            fontSize: '0.875rem',
        }),
        groupHeading: (base) => ({
            ...base,
            color: '#6b7280',
            fontSize: '0.75rem',
            fontWeight: '600',
            textTransform: 'uppercase',
            padding: '8px 12px',
            borderBottom: '1px solid #e5e7eb',
            marginBottom: '4px',
        }),
    };

    //ESTADOS LOCAL - para contador de caracteres
    const [textInput1, setTextInput1] = useState(''); //input descripcion_proyecto
    const [textInput2, setTextInput2] = useState(''); //input lc_23_observaciones_localizacion

    //inicia estados locales para mantener cambios en local hasta sincronizar con el padre
    //crear un objeto vacio, para luego ir agregando las keys que tiene cambios
    const [localData, setLocalData] = useState({
        nombre_obra: '',
        beneficiarios: '',
        plazo_obra: '',
        partido: '',
        partido_nombre: '',
        barrio_tipo: '',
        barrio_rppvap_nombre: '',
        barrio_otro_nombre: ''

    });
    console.log("PUMA CAMBIOS LOCALES", localData)

    // Estados RECUPERAR
    const [nombrePartido, setNombrePartido] = useState(""); //6FEB25 - usar para el component SubsidioForm
    const [tipoSubsidio, setTipoSubsidio] = useState('');
    console.log("Tipo de Subsidio estado local en hijo --->", tipoSubsidio)

    const [organismoSolicitante, setOrganismoSolicitante] = useState('');
    console.log("Organismo Solicitante estado local en hijo --->", organismoSolicitante)

    const [formDataTipo, setFormDataTipo] = useState([]); //7-FEB-25 para manejar estado del formulario de Tipo/Subtipo
    console.log("Datos Tipo Proyecto y SubTipo", formDataTipo)

    //const [formattedValue, setFormattedValue] = useState(''); // Valor formateado visualmente (con $)
    //const [numericValue, setNumericValue] = useState(null); // Valor numérico real

    const [selectedOptions, setSelectedOptions] = useState([]);

    // Estados para manejar nombre_obra con prefijo en etapa 2
    const [nombreObraVisual, setNombreObraVisual] = useState('');
    const [nombreObraReal, setNombreObraReal] = useState('');

    const prefijoEtapa2 = datosGenerales.area_responsable === AREA_RESP_MICROCREDITOS ? 'REND - ' : 'EII - ';

    // Sincronizar estados locales con datosGenerales.nombre_obra
    useEffect(() => {
        if (isSegundaEtapa || datosGenerales.tipo_microcredito === 'EXP_RENDIC') {
            if (datosGenerales.nombre_obra) {
                if (!datosGenerales.nombre_obra.startsWith(prefijoEtapa2)) {
                    setNombreObraVisual(prefijoEtapa2 + datosGenerales.nombre_obra);
                } else {
                    setNombreObraVisual(datosGenerales.nombre_obra);
                }
            } else {
                setNombreObraVisual(prefijoEtapa2);
            }
        } else {
            setNombreObraVisual(datosGenerales.nombre_obra || '');
            setNombreObraReal(datosGenerales.nombre_obra || '');
        }
    }, [datosGenerales.nombre_obra, datosGenerales.etapa, datosGenerales.area_responsable, datosGenerales.tipo_microcredito]);

    const [startDate, setStartDate] = useState(new Date());

    // 1. Obtener referentes con useQuery
    //abre recuperado
    /* //REFERENTES por ahora se va
    const { data: referentes = [], refetch } = useQuery({
        queryKey: ['referentes'],
        queryFn: () => fetch('/api/todosReferentes').then(res => res.json()),
        select: (data) => [
            { value: '', label: 'Seleccionar...', disabled: true }, // Opción inicial
            ...data.map(item => ({
                value: item.id.toString(),
                label: item.nombre
            }))
        ],
        onSuccess: (transformedData) => {
            console.log('Referentes transformados:', transformedData);
        }
    });

    const { registerRefetch } = useReferentes();

    useEffect(() => {
        registerRefetch(refetch);
    }, [refetch]);

    //24-abr-2025: estado para las options recibidas desde la api
    const [opcionesReferente, setOpcionesReferente] = useState([]);
    */
    //cierra recuperado

    const bloquear = false; //harcodeado ----> CHANGE #21FEB

    // === ESTADOS Y LÓGICA PARA CONTACTOS ===
    //
    // Antes era un solo contacto con un datalist de la tabla vieja `contactos`
    // (66 filas, de todas las ONGs juntas). Ahora es una lista que se elige del
    // catalogo de la ONG de ESTA obra, y se guarda como array en cg_12.
    //
    // parsearContactosObra devuelve {contactos, forma}: la forma es para
    // diagnosing, porque si al abrir una obra aparece "texto" u "objeto" es una
    // obra cargada antes de la migracion 062, no un error.
    const { contactos: contactosObra, forma: formaContactos } = useMemo(
        () => parsearContactosObra(datosGenerales.contacto_proyecto),
        [datosGenerales.contacto_proyecto]
    );

    useEffect(() => {
        if (formaContactos === 'texto' || formaContactos === 'objeto') {
            console.info(
                `[CONTACTOS] cg_12 en formato "${formaContactos}" (obra anterior a la migracion 062). ` +
                'Se muestra igual y se guarda como array al editar.'
            );
        }
    }, [formaContactos]);

    const handleContactosChange = (nuevos) => {
        updateField('formA', 'datosGenerales', 'contacto_proyecto', JSON.stringify(nuevos));
    };

    // useEffect para seleccionar automáticamente el programa cuando el área tiene un solo programa disponible
    useEffect(() => {
        const area = datosGenerales.area_responsable;

        // 1. Buscamos las opciones directamente en el mapa. 
        // Si no encuentra el área, usamos un arreglo vacío por defecto (|| [])
        const programaOptions = PROGRAM_OPTIONS_MAP[area] || [];

        // 2. Lógica de auto-selección intacta pero mucho más legible
        // loadingRef en FormContext suprime SET_DIRTY durante carga inicial de edición,
        // por lo que podemos usar updateField (marca dirty solo cuando usuario interactúa)
        if (programaOptions.length === 1 && !datosGenerales.programa_lineamiento) {
            updateField('formA', 'datosGenerales', 'programa_lineamiento', programaOptions[0].value);
        }
    }, [datosGenerales.area_responsable]); // Solo se ejecuta cuando cambia el área

    //4- UseMemo y useCallbacks******************
    //NUEVO callback solo para pruebas nombre_obra -NO USAR POR AHORA -21nov2025-


    //NUEVA #21FEB
    //ANTES un callback para manejar los cambios en los inputs
    /*
    const handleInputChange = useCallback((event) => {
        const { name, value } = event.target;
        console.log("name", name)
        console.log("value", value)

        
        // Actualiza una parte del 'registro' existente, manteniendo la inmutabilidad
        //agregar casos especiales
        if (name === 'beneficiarios') {
            if (value === '' || /^\d{0,5}$/.test(value)) {
                onRegistroChange({ ...registro, beneficiarios: value }); //RECUPERADO #21FEB
            }
        } else if (name === 'plazo_obra') {
            console.log("ESTÄ ENTRANDO ACA???")
            if (value === '' || /^\d{0,3}$/.test(value)) {
                onRegistroChange({ ...registro, plazo_obra: value }); //RECUPERADO #21FEB
            }
        } else if (name == 'partido') { //maneja el estado de dos propiedades distintas
            if (value > 0) {
                const select = event.target;
                const opcionSeleccionada = select.options[select.selectedIndex];
                const textoOpcionSeleccionada = opcionSeleccionada.text;
                onRegistroChange({ ...registro, partido: value, partido_nombre: textoOpcionSeleccionada }); //RECUPERADO #21FEB
                setNombrePartido(textoOpcionSeleccionada)//(e.target.options[e.target.selectedIndex].text)
            } else {
                onRegistroChange({ ...registro, partido: value, partido_nombre: "" }); // ----> RECUPERADO #21FEB
            }            
        } 
       
        else if (name === 'barrio_tipo') {
            onRegistroChange({ ...registro, barrio_tipo: value });
        } else {
            onRegistroChange({ ...registro, [name]: value, });
        }

        if (name === 'descripcion_proyecto') {
            //actualizamos el estado local -solo para el contador de caracteres
            setTextInput1(value)            
        }

        if (name === 'lc_23_observaciones_localizacion') {
            //actualizamos el estado local -solo para el contador de caracteres
            setTextInput2(value)            
        }

    }, [registro, onRegistroChange]);*/


    // Función reutilizable para formatear números con separador de miles
    //Se usa en :
    // - handleInputChange para beneficiarios
    // - handleInputChange para plazo_obra
    const formatearNumero = (valor) => {
        const soloNumeros = valor.replace(/\D/g, ''); // Eliminar todo lo que no sea dígito
        if (soloNumeros === '') return '';
        return parseInt(soloNumeros, 10).toLocaleString('es-AR'); // Formatear con separador de miles
    };

    const handleInputChangeNombreObra = useCallback((event) => {
        const { value } = event.target;
        const prefijo = datosGenerales.area_responsable === AREA_RESP_MICROCREDITOS ? 'REND - ' : 'EII - ';

        if (isSegundaEtapa) {
            if (!value.startsWith(prefijo)) {
                const valorVisual = prefijo + value;
                setNombreObraVisual(valorVisual);
                updateField('formA', 'datosGenerales', 'nombre_obra', valorVisual);
            } else {
                setNombreObraVisual(value);
                updateField('formA', 'datosGenerales', 'nombre_obra', value);
            }
        } else {
            setNombreObraVisual(value);
            setNombreObraReal(value);
            updateField('formA', 'datosGenerales', 'nombre_obra', value);
        }
    }, [isSegundaEtapa, datosGenerales.area_responsable, updateField]);

    const handleModalidadChange = useCallback((event) => {
        const value = event.target.value;
        updateField('formA', 'datosGenerales', 'modalidad', value);
    }, [updateField]);

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;

        // Para campos de tipo checkbox
        const fieldValue = type === 'checkbox' ? checked : value;

        if (name === 'partido') {
            // Manejar el cambio de partido
            if (value > 0) {
                const select = e.target;
                const opcionSeleccionada = select.options[select.selectedIndex];
                const textoOpcionSeleccionada = opcionSeleccionada.text;

                // Actualizar el contexto
                updateField('formA', 'datosGenerales', 'partido', value);
                updateField('formA', 'datosGenerales', 'partido_nombre', textoOpcionSeleccionada);

                // Actualizar el estado local si es necesario
                setNombrePartido(textoOpcionSeleccionada);
            } else {
                // Si no hay partido seleccionado
                updateField('formA', 'datosGenerales', 'partido', value);
                updateField('formA', 'datosGenerales', 'partido_nombre', '');
                setNombrePartido('');
            }
        } else if (name === 'area_responsable') {
            // Si el área cambia (a cualquier valor diferente), resetear programa y modalidad
            const areaAnterior = datosGenerales.area_responsable;
            if (value !== areaAnterior) {
                updateField('formA', 'datosGenerales', 'area_responsable', fieldValue);
                updateField('formA', 'datosGenerales', 'programa_lineamiento', null);
                updateField('formA', 'datosGenerales', 'modalidad', null);
            }
        } else if (name === 'programa_lineamiento') {
            // Si el programa cambia y queda vacío o nulo, resetear modalidad
            if (value === '' || value === null) {
                updateField('formA', 'datosGenerales', 'programa_lineamiento', null);
                updateField('formA', 'datosGenerales', 'modalidad', null);
            } else {
                updateField('formA', 'datosGenerales', 'programa_lineamiento', fieldValue);
            }
        } else if (name === 'beneficiarios' || name === 'plazo_obra') {
            // Campos numéricos con máscara de miles
            updateField('formA', 'datosGenerales', name, formatearNumero(value));
        } else if (name.includes('.')) {
            // Para campos anidados (si es necesario)
            const [section, field] = name.split('.');
            updateField('formA', section, field, fieldValue);
        } else {
            // Para campos en datosGenerales
            updateField('formA', 'datosGenerales', name, fieldValue);
        }
    };

    //console.log("ACCION C ---form A--->", accion)
    //const socket = io({ path: "/socket.io" }); // 13-ENE-25
    //const socket = useContext(SocketContext) 

    // Formatear la fecha al desestructurar
    //ANTES
    /*
    const fecha_actualizacion = useMemo(() => { //crea una nueva variable fecha_actualizacion, no tiene relacion con registro.fecha_actualizacion
        if (!fechaActualizacionRaw) return null;
        try {
            const fecha = new Date(fechaActualizacionRaw);
            if (isNaN(fecha.getTime())) return null;
            
            const fechaAjustada = new Date(fecha)
            fechaAjustada.setMinutes(fechaAjustada.getMinutes() + fechaAjustada.getTimezoneOffset())
            return fechaAjustada;
        } catch (error) {
            console.error('Error al formatear fecha:', error);
            return null;
        }
    }, [fechaActualizacionRaw]); 
    */
    // Reemplaza el useMemo antiguo por esto:
    const fechaActualizacion = useMemo(() => {
        if (!datosGenerales.fecha_actualizacion) return null;
        if (estadoAppX === "nuevo") {
            return null;
        }
        try {
            const fecha = new Date(datosGenerales.fecha_actualizacion);
            if (isNaN(fecha.getTime())) return null;

            const fechaAjustada = new Date(fecha);
            fechaAjustada.setMinutes(fechaAjustada.getMinutes() + fechaAjustada.getTimezoneOffset());
            return fechaAjustada;
        } catch (error) {
            console.error('Error al formatear fecha:', error);
            return null;
        }
    }, [datosGenerales.fecha_actualizacion]);

    const openModal = () => setModalIsOpen(true);
    const closeModal = () => setModalIsOpen(false);

    /* ----> RECUPERAR #21FEB
    useEffect(()=>{

        if(socket){

            const procesarEditInput = (usuario, data) =>{
                console.log("QUE USUARIO ESTA EDITANDO", usuario)
                console.log("QUE INPUT ID ESTÁ EDITANDO OTRO USUARIO", data)
    
                //setArrayInputs(...arrayInputs, data.value)
            }
            
            socket.on("input_editado_por_otro_usuario", procesarEditInput)            
    
            return () => {
                socket.off("input_editado_por_otro_usuario", procesarEditInput)
            }              

        }          

    }, [])
    */

    //5- UseEffects *******************
    // Agrega este efecto para depurar
    useEffect(() => {
        console.log('TORO FormA - formA actualizado:', formA);
        console.log('TORO FormA - datosGenerales actualizado:', datosGenerales);
    }, [formA, datosGenerales]);

    //NOTA #19NIV25: pensar como pasar estado de 'registro' cuando cambio de pestaña o cuando doy guardar desde 'Inicio'
    // al previsualizr PDF
    //Evitar pasar estado (y re render) por cada cambio en formA

    //solo al montar
    /*
    useEffect(() =>{
        setLocalData({
            nombre_obra: registro.nombre_obra || '',
        })
    }, [registro.nombre_obra])
    */

    // useEffect para inicializar los estados cuando el componente se monta en modo de edición
    /*
     useEffect(() => {
        if (registro && registro.monto_obra) {
            const numericMonto = parseFloat(registro.monto_obra);
            if (!isNaN(numericMonto)) {
                // Formatear el valor numérico para la vista
                const formatted = `$${numericMonto.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.')}`;
                setFormattedValue(formatted);
                setNumericValue(numericMonto);
            }
        } else if(registro && estadoAppX === "nuevo"){
            setFormattedValue('');
            setNumericValue(null);
        }
    }, [registro]); // Se ejecuta cada vez que el objeto 'obra' cambia

    */

    // useEffect para cargar barrios RPPVAP cuando se selecciona el tipo de barrio
    useEffect(() => {
        const rppvapSeleccionado = tiposBarrioSeleccionados && tiposBarrioSeleccionados.some(t => t.value === 'RPPVAP');
        const partidoPrincipal = datosGenerales.partido;
        const fetchKey = `${partidoPrincipal}_${rppvapSeleccionado}_${habilitarMultiplesPartidos}_${partidosSeleccionados?.length}`;
        if (barriosRPPVAPKeyRef.current === fetchKey) return;
        if (!rppvapSeleccionado || !partidoPrincipal) {
            barriosRPPVAPKeyRef.current = '';
            if (barriosRPPVAP.length > 0) setBarriosRPPVAP([]);
            return;
        }
        barriosRPPVAPKeyRef.current = fetchKey;
        let url;
        if (habilitarMultiplesPartidos && partidosSeleccionados && partidosSeleccionados.length > 0) {
            const partidosIds = [partidoPrincipal, ...partidosSeleccionados.map(p => p.value)].join(',');
            url = `/api/barrios/barrios_rppvap?partidos=${partidosIds}`;
        } else {
            url = `/api/barrios/barrios_rppvap?partido=${partidoPrincipal}`;
        }
        let cancelled = false;
        fetch(url, {
            headers: { 'Authorization': `Bearer ${token}` }
        })
            .then(res => { if (!res.ok) throw new Error(`HTTP ${res.status}`); return res.json(); })
            .then(data => {
                if (cancelled) return;
                if (!Array.isArray(data)) throw new Error('Respuesta inválida');
                setBarriosRPPVAP(data);
            })
            .catch(err => console.error('Error fetching barrios:', err));
        return () => { cancelled = true; };
    }, [tiposBarrioSeleccionados, datosGenerales.partido, habilitarMultiplesPartidos, partidosSeleccionados, token]);

    // useEffect para cargar barrios RENABAP cuando se selecciona el tipo de barrio
    useEffect(() => {
        const renabapSeleccionado = tiposBarrioSeleccionados && tiposBarrioSeleccionados.some(t => t.value === 'RENABAP');
        const partidoPrincipal = datosGenerales.partido;
        const fetchKey = `${partidoPrincipal}_${renabapSeleccionado}_${puedeVerRENABAP}_${habilitarMultiplesPartidos}_${partidosSeleccionados?.length}`;
        if (barriosRENABAPKeyRef.current === fetchKey) return;
        if (!renabapSeleccionado || !partidoPrincipal || !puedeVerRENABAP) {
            barriosRENABAPKeyRef.current = '';
            if (barriosRENABAP.length > 0) setBarriosRENABAP([]);
            return;
        }
        barriosRENABAPKeyRef.current = fetchKey;
        let url;
        if (habilitarMultiplesPartidos && partidosSeleccionados && partidosSeleccionados.length > 0) {
            const partidosIds = [partidoPrincipal, ...partidosSeleccionados.map(p => p.value)].join(',');
            url = `/api/barrios/barrios_renabap?partidos=${partidosIds}`;
        } else {
            url = `/api/barrios/barrios_renabap?partido=${partidoPrincipal}`;
        }
        let cancelled = false;
        fetch(url, {
            headers: { 'Authorization': `Bearer ${token}` }
        })
            .then(res => { if (!res.ok) throw new Error(`HTTP ${res.status}`); return res.json(); })
            .then(data => {
                if (cancelled) return;
                setBarriosRENABAP(data);
            })
            .catch(err => console.error('Error fetching barrios RENABAP:', err));
        return () => { cancelled = true; };
    }, [tiposBarrioSeleccionados, datosGenerales.partido, habilitarMultiplesPartidos, partidosSeleccionados, puedeVerRENABAP, token]);

    // useEffect para limpiar barrios cuando se deselecciona un tipo de barrio
    useEffect(() => {
        if (!tiposBarrioSeleccionados || tiposBarrioSeleccionados.length === 0) {
            // Auto-derivar tipos desde los arrays de barrios
            const autoTipos = [];
            if (barriosSeleccionados && barriosSeleccionados.length > 0) {
                autoTipos.push({ value: 'RPPVAP', label: 'Barrio RPPVAP' });
            }
            if (barriosRENABAPSeleccionados && barriosRENABAPSeleccionados.length > 0) {
                autoTipos.push({ value: 'RENABAP', label: 'Barrio RENABAP' });
            }
            if (autoTipos.length > 0) {
                updateField('formA', 'tiposBarrioSeleccionados', null, autoTipos);
                return;
            }
            // Sin tipos ni barrios, limpiar todo
            if (barriosSeleccionados && barriosSeleccionados.length > 0) {
                updateField('formA', 'barriosSeleccionados', null, []);
            }
            if (barriosRENABAPSeleccionados && barriosRENABAPSeleccionados.length > 0) {
                updateField('formA', 'barriosRENABAPSeleccionados', null, []);
            }
            return;
        }

        // Auto-derivar tipos faltantes desde los arrays de barrios
        const nuevosTipos = [...(tiposBarrioSeleccionados || [])];
        if (barriosSeleccionados?.length > 0 && !nuevosTipos.some(t => t.value === 'RPPVAP')) {
            nuevosTipos.push({ value: 'RPPVAP', label: 'Barrio RPPVAP' });
        }
        if (barriosRENABAPSeleccionados?.length > 0 && !nuevosTipos.some(t => t.value === 'RENABAP')) {
            nuevosTipos.push({ value: 'RENABAP', label: 'Barrio RENABAP' });
        }
        if (nuevosTipos.length !== (tiposBarrioSeleccionados || []).length) {
            updateField('formA', 'tiposBarrioSeleccionados', null, nuevosTipos);
            return;
        }

        // Verificar si OTRO sigue seleccionado, si no, limpiar barrio_otro_nombre
        const otroSeleccionado = tiposBarrioSeleccionados.some(t => t.value === 'OTRO');
        if (!otroSeleccionado && datosGenerales.barrio_otro_nombre) {
            updateField('formA', 'datosGenerales', 'barrio_otro_nombre', '');
        }
    }, [tiposBarrioSeleccionados, barriosSeleccionados, barriosRENABAPSeleccionados, datosGenerales.barrio_otro_nombre, updateField]);

    // useEffect para limpiar barrios cuando se elimina un partido adicional o cambia el partido principal
    useEffect(() => {
        // En modo edición: solo si hay múltiples partidos
        // En modo nuevo: siempre limpiar barrios de partidos que no están seleccionados
        if (estadoAppX === 'ediT' && !habilitarMultiplesPartidos) return;

        // Obtener IDs de partidos actuales (principal + adicionales)
        // Normalizar a 3 dígitos para coincidir con formato de código de barrio
        const partidosActuales = [
            String(datosGenerales.partido).padStart(3, '0'),
            ...partidosSeleccionados.map(p => String(p.value).padStart(3, '0'))
        ];

        // Limpiar barrios RPPVAP que pertenezcan a partidos eliminados
        // Para RPPVAP, los primeros 3 dígitos del value corresponden al partido
        if (barriosSeleccionados && barriosSeleccionados.length > 0) {
            console.log('DEBUG limpieza - partidosActuales:', partidosActuales);
            console.log('DEBUG limpieza - barriosSeleccionados:', barriosSeleccionados.map(b => ({ value: b.value, partido: String(b.value).substring(0, 3) })));

            const barriosFiltrados = barriosSeleccionados.filter(barrio => {
                const partidoBarrio = String(barrio.value).substring(0, 3);
                const estaEnPartidos = partidosActuales.includes(partidoBarrio);
                console.log('DEBUG limpieza - barrio:', barrio.value, 'partido:', partidoBarrio, 'incluido:', estaEnPartidos);
                return estaEnPartidos;
            });

            console.log('DEBUG limpieza - barriosFiltrados:', barriosFiltrados.length, 'de', barriosSeleccionados.length);

            if (barriosFiltrados.length !== barriosSeleccionados.length) {
                updateField('formA', 'barriosSeleccionados', null, barriosFiltrados);
            }
        }

        // Para RENABAP, verificar si hay alguna propiedad que indique el partido
        // Por ahora, mantener todos los barrios RENABAP seleccionados
        // (Si en el futuro los barrios RENABAP tienen info de partido, se puede implementar similar)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [partidosSeleccionados, datosGenerales.partido, estadoAppX, habilitarMultiplesPartidos]);

    useEffect(() => {
        if (estadoAppX === 'nuevo' || estadoAppX === 'nuevo_etapa2') {

            const fechaActual = new Date();
            // Actualizar tanto la fecha de carga como la de actualización
            updateField('formA', 'datosGenerales', 'fecha_carga', fechaActual);
            //si es nuevo fecha_actualizacion debe ser null
            updateField('formA', 'datosGenerales', 'fecha_actualizacion', null);


        } else if (estadoAppX === 'ediT') {

            //updateField('formA', 'datosGenerales', 'fecha_actualizacion', new Date()); //-----> se maneja en el server al guardar la edicion
        }
    }, [estadoAppX])

    // Lógica de Validación
    /*
    useEffect(() => {        

        const esEncargadoValido = String(encargado_proyecto).trim() !== ''; 
        const esAreaValido = String(area_responsable).trim() !== ''; 
        const esPartidoValido = String(partido).trim() !== ''; 
        
        const camposObligatoriosLlenos = 
            (localData.nombre_obra || '').trim() !== '' && 
            esEncargadoValido && 
            esAreaValido && 
            esPartidoValido; 
        
        // Comunicar el estado de validación al Padre
        handleValidationChange(camposObligatoriosLlenos);
        
    }, [localData.nombre_obra, encargado_proyecto, area_responsable, partido, handleValidationChange]); // ¡Añadir 'partido' aquí!
    */

    /*
    NO USAR NADA DE ESTO POR AHORA -21nov2025-
    // Sincronización al desmontar (cuando se cambia de pestaña)
    useEffect(() => {
        // Función de limpieza que se ejecuta justo antes de que el componente se desmonte

        // 3. Devolvemos la función de limpieza
        return () => {
            // 4. Esta línea se ejecuta ANTES del próximo render Y al desmontar.

            // 5. Establecer isMounted a false en el cleanup.
            // Si se ejecuta justo antes de unmount, esta es la última vez que se ejecuta.
            isMounted.current = false;

            // 6. ¡La Clave! Solo sincronizar si isMounted es FALSE 
            //    (indicando que el componente va a ser desmontado/reemplazado)
            if (isMounted.current === false) {
                //alSincronizar(localData);
                //onRegistroChange({ ...registro, nombre_obra: localData.nombre_obra, })

                //otra prueba
                handleLocalDataChange(localData);
                console.log('PUMA FormA sincronizado con el padre al cambiar de pestaña.', localData);
            }
        };
    }, [alSincronizar, localData]); // Depende de la función de sincronización y el estado local
    //alSincronizar, localData <-- Array de dependencias vacío para que solo se ejecute en el desmontaje
    */

    /*
    // Sincronización al desmontar (cuando se cambia de pestaña)
    useEffect(() => {
        // Función de limpieza que se ejecuta justo antes de que el componente se desmonte
        return () => {
            // Verificar si hay datos locales para sincronizar
            if (Object.keys(localData).length > 0) {
                console.log('PUMA Sincronizando datos locales con el padre:', localData);
                alSincronizar(localData); // Envía los datos locales al padre
            } else {
                console.log('No hay cambios locales para sincronizar');
            }
        };
    }, [alSincronizar]); // Solo dependemos de alSincronizar
    */

    // 6- Funciones Manejo de fechas y Handlers******************
    //eliminar _fechaCarga
    //#19dic205 - comentar por ahora _fecha_imputacion
    /*
    let _fecha_imputacion = null;
    if (datosGenerales.fecha_imputacion === null) {
        _fecha_imputacion = null;
    } else if (datosGenerales.fecha_imputacion !== null || datosGenerales.fecha_imputacion !== "") {
        _fecha_imputacion = new Date(datosGenerales.fecha_imputacion);
        _fecha_imputacion.setMinutes(_fecha_imputacion.getMinutes() + _fecha_imputacion.getTimezoneOffset())
    }
    */

    /**FUNCIONES */
    //contador de caracteres #19NOV25:
    //podría definir un limite constante, pero de esta manera se puede usar para cualquier input e ir variando el limite
    const contadorCaracteresRestantes = (limite, texto) => {
        // Si el texto es null o undefined, usar string vacío
        const longitud = texto ? texto.length : 0;
        // Asegurarse de que el límite sea un número válido
        const limiteValido = limite || 0;
        // Calcular caracteres restantes, asegurando que no sea negativo
        return Math.max(0, limiteValido - longitud);
    }

    const onChange = e => {
        console.log(e)
        console.log("SI EL CAMBIO VIENE DESDE SOCKET TAMBIEN LO TOMA ACA???")

        // ** validaciones
        //const valor = e.target.value;
        //const nombre = e.target.name;
        const { name, value } = e.target; //lo mismo en una sola linea        

        // Validar que el valor sea un número entero
        if (name === 'beneficiarios') {
            if (value === '' || /^\d{0,5}$/.test(value)) {
                //setRegistro({...registro, beneficiarios: value}); //RECUPERADO #21FEB
            }
        } else if (name === 'plazo_obra') {
            console.log("ESTÄ ENTRANDO ACA???")
            if (value === '' || /^\d{0,3}$/.test(value)) {
                //setRegistro({...registro, plazo_obra: value}); //RECUPERAR #21FEB
            }
        } else if (name == 'partido') { //maneja el estado de dos propiedades distintas
            if (value > 0) {
                const select = e.target;
                const opcionSeleccionada = select.options[select.selectedIndex];
                const textoOpcionSeleccionada = opcionSeleccionada.text;
                //setRegistro({...registro, partido: value, partido_nombre: textoOpcionSeleccionada}); //RECUPERADO #21FEB
            } else {
                //setRegistro({...registro, partido: value, partido_nombre: ""}); // ----> RECUPERADO #21FEB
            }

        } else {
            //setRegistro({ ...registro, [e.target.name]: e.target.value }); // --->RECUPERAR #21FEB
        }


        //setEditandoInput({ ...editandoInput, id_input_editando : e.target.name}) ----> RECUPERAR #21FEB
        //setModoEdicion("manual") ----> RECUPERAR #21FEB ??????
        if (e.target.name === 'partido') {
            setNombrePartido(e.target.options[e.target.selectedIndex].text)
        }
    }

    /*const onChangeLocalizacion = (e) => { //cambios localizacion
        const { name, value } = e.target;

        setFormDataLocalizacion(prev => ({
            ...prev,
            [name]: value
        }));
    };*/


    //ANTES
    /*
    const handleChangeDate = (item) => {
        const fecha = item.value;
        //setRegistro({ ...registro, [item.name]: fecha }); //RECUPERAR #21FEB
        onRegistroChange({ ...registro, [item.name]: fecha })
    }
    */
    // Después
    const handleChangeDate = (item) => {
        const fecha = item.value;
        updateField('formA', 'datosGenerales', item.name, fecha);
    }

    //ANTES
    /*
    const handleChangeFormattedValue = (newValue) => {
        setFormattedValue(newValue)
    }
    */
    // Después
    const handleChangeFormattedValue = (newValue) => {
        updateField('formA', 'datosGenerales', 'formattedValue', newValue);
    }

    //ANTES
    /*
    const handleChangeNumericValue = (newNumber) => {
        setNumericValue(newNumber)
    } 
    */
    // Después
    const handleChangeNumericValue = (newNumber) => {
        updateField('formA', 'datosGenerales', 'numericValue', newNumber);
    }

    const handleChange = (selectedOption) => {
        setSelectedOptions(selectedOption);
    };

    //MANTENER: manejar fecha de actualizacion con una funcion generica, evitar que se muestre un dia menos que el recibido desde la base
    //ANTES
    /*
    const manejarFechaActualizacion = (fecha_recibida) => {
        // Si no hay fecha o es una cadena vacía, retornar null
        if (!fecha_recibida) return null;
        
        // Crear un objeto Date a partir del input
        const fecha = new Date(fecha_recibida);
        
        // Verificar si la fecha es válida
        if (isNaN(fecha.getTime())) {
            console.error('Fecha inválida recibida:', fecha_recibida);
            return null;
        }
        
        // Ajustar por la zona horaria
        fecha.setMinutes(fecha.getMinutes() + fecha.getTimezoneOffset());
        
        // Retornar la fecha formateada
        return fecha;
    }
    */
    // Uso con el contexto
    const handleFechaChange = (date, fieldName) => {
        updateField('formA', 'datosGenerales', fieldName, date);
    }

    //#24nov2025 - un useEffect para manejar el cambio de identificacion catastral en NO---> limpiar datos catastrales, dejar solo cuadro de calles
    useEffect(() => {
        if (datosGenerales.lc_22_identificacion_catastral === 'NO') {
            updateField('formA', 'datosGenerales', 'lc_22_1_datos_catastrales', '');
        }
    }, [datosGenerales.lc_22_identificacion_catastral]);

    // Auto-set modalidad a "etapa I" para Mejoras Habitacionales
    useEffect(() => {
        if (
            datosGenerales.area_responsable === 'ÁREA DE MEJORAS' &&
            datosGenerales.programa_lineamiento === "Mejoras Habitacionales Trabajar en la Casa" &&
            !datosGenerales.modalidad &&
            !isSegundaEtapa
        ) {
            updateField('formA', 'datosGenerales', 'modalidad', 'etapa I');
        }
    }, [datosGenerales.area_responsable, datosGenerales.programa_lineamiento, datosGenerales.modalidad, isSegundaEtapa, updateField]);


    const fechaCargaAjustada = adjustDateForTimezone(datosGenerales.fecha_carga);
    const fechaActualizacionAjustada = adjustDateForTimezone(datosGenerales.fecha_actualizacion);
    const fechaImputacionAjustada = adjustDateForTimezone(datosGenerales.fecha_imputacion);

    return (
        //quite de form ---> md:max-w-sm
        // 
        //className= {`${bloquear ? "bg-gray-600  border-solid border-2 border-yellow-800 px-2 py-4 pointer-events-none opacity-80" : " bg-gray-600  border-solid border-2 border-yellow-800 px-2 py-4 "}`}
        <>

            <div className={`${bloquear ? "p-4 bg-white dark:bg-gray-900 pointer-events-none opacity-80 h-auto" : "p-4 bg-white dark:bg-gray-900 h-auto "}`} >

                <form className="space-y-2 ">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

                        <div className="space-y-4 h-auto"> {/* COLUMNA UNO - mitad de DAtos generales*/}
                            <div className="flex items-center gap-3 mb-2">
                                <h2 className="text-xl font-bold dark:text-white">DATOS GENERALES</h2>
                                {isSegundaEtapa && datosGenerales.area_responsable !== AREA_RESP_MICROCREDITOS && (
                                    <div className="px-3 py-1 bg-blue-100 text-blue-800 rounded-md text-sm font-medium border border-blue-300">
                                        ETAPA II - {estadoAppX === 'nuevo_etapa2' ? 'Se vinculará a:' : 'Vinculado a:'} {datosGenerales.id_etapa1_referencia}
                                    </div>
                                )}
                            </div>

                            <div className="px-2">
                                <Label htmlFor="id">Id</Label>
                                <Input
                                    readOnly
                                    id="id"
                                    name="id"
                                    type="text"
                                    placeholder="id"
                                    value={datosGenerales.id_partido_obra || ''}
                                />
                            </div>

                            <div className="px-2">
                                <Label htmlFor="partido">Partido</Label>
                                <Select_simple
                                    id="partido"
                                    //options={optionsPartido}
                                    options={[
                                        { value: '', label: 'Seleccionar...' },
                                        ...optionsPartido.map(c => ({ value: c.value, label: c.label }))
                                    ]}
                                    name="partido"
                                    value={datosGenerales.partido}
                                    onChange={e => handleInputChange(e)}
                                    required
                                    disabled={(estadoAppX === 'ediT' && datosGenerales.id_partido_obra) || estadoAppX === 'nuevo_etapa2' || estadoAppX === 'edit_etapa2' || isSegundaEtapa}
                                />
                                <div>
                                    <p className="text-sm text-gray-500">
                                        Indicar el partido de mayor preponderancia
                                    </p>
                                </div>
                                {(datosGenerales.partido === 0 || datosGenerales.partido === "" || datosGenerales.partido === undefined) && (
                                    <p className="text-sm text-red-600 mt-1">
                                        *⚠️ Campo obligatorio
                                    </p>
                                )}
                                {puedeCambiarPartido && (
                                    <div className="mt-2">
                                        <button
                                            type="button"
                                            onClick={abrirModalCambioPartido}
                                            className="px-3 py-1.5 text-sm font-medium rounded-md border border-amber-500 text-amber-700 dark:text-amber-300 hover:bg-amber-50 dark:hover:bg-amber-900/30 transition-colors"
                                        >
                                            Cambiar partido
                                        </button>
                                        <p className="text-xs text-gray-500 mt-1">
                                            Recalcula el ID ubicando el proyecto en otro partido (borra el original en forma lógica)
                                        </p>
                                    </div>
                                )}
                            </div>

                            {/* Checkbox para habilitar selección múltiple de partidos */}
                            <div className="px-2 mt-2">
                                <label className="flex items-center space-x-2 cursor-pointer">
                                    <input
                                        type="checkbox"
                                        checked={habilitarMultiplesPartidos}
                                        onClick={(e) => {
                                            const newValue = !habilitarMultiplesPartidos;
                                            updateField('formA', 'habilitarMultiplesPartidos', null, newValue);
                                            if (!newValue) {
                                                updateField('formA', 'partidosSeleccionados', null, []);
                                            }
                                        }}
                                        className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                                    />
                                    <span className="text-sm text-gray-700 dark:text-gray-300">
                                        ¿El proyecto abarca múltiples partidos?
                                    </span>
                                </label>
                            </div>

                            {/* Select múltiple de partidos (visible solo si está habilitado) */}
                            {habilitarMultiplesPartidos && (
                                <div className="px-2 mt-2">
                                    <Label htmlFor="partidos_multiples">Partidos adicionales</Label>
                                    <Select
                                        id="partidos_multiples"
                                        isMulti
                                        options={optionsPartido}
                                        value={partidosSeleccionados}
                                        onChange={(selected) => updateField('formA', 'partidosSeleccionados', null, selected || [])}
                                        placeholder="Seleccionar partidos..."
                                        className="mt-1"
                                        styles={customSelectStyles}
                                    />
                                    <p className="text-xs text-gray-500 mt-1">
                                        Seleccione todos los partidos donde se desarrolla el proyecto
                                    </p>
                                </div>
                            )}

                            <div className="px-2">
                                <Label htmlFor="nombre_obra">Nombre del Proyecto / Alias</Label>
                                <Input
                                    id="nombre_obra"
                                    name="nombre_obra"
                                    type="text"
                                    placeholder={isSegundaEtapa ? "EII - Nombre del proyecto" : "Nombre del Proyecto / Alias"}
                                    value={isSegundaEtapa ? nombreObraVisual : (datosGenerales.nombre_obra || '')}
                                    onChange={isSegundaEtapa ? handleInputChangeNombreObra : e => handleInputChange(e)}
                                />
                                {!isSegundaEtapa && (datosGenerales.nombre_obra || '').trim() === '' && (
                                    <p className="text-sm text-red-600 mt-1">
                                        *⚠️ Campo obligatorio
                                    </p>
                                )}
                                {!isSegundaEtapa && (datosGenerales.nombre_obra || '').trim() === 'EI -' && (
                                    <p className="text-sm text-red-600 mt-1">
                                        *⚠️ Complete el nombre del proyecto
                                    </p>
                                )}
                                {isSegundaEtapa && nombreObraVisual.trim() === 'EII -' && (
                                    <p className="text-sm text-red-600 mt-1">
                                        *⚠️ Complete el nombre del proyecto
                                    </p>
                                )}
                            </div>

                            <div className="grid grid-cols-2 gap-4 px-2">{/*un div para las dos fechas */}
                                <div className="w-full">
                                    <Label htmlFor="fecha carga">Fecha de carga</Label>
                                    <div className="mt-1">
                                        <DatePicker
                                            disabled
                                            required
                                            dateFormat="dd/MM/yyyy"
                                            selected={fechaCargaAjustada}//{datosGenerales.fecha_carga}
                                            className="w-full border border-gray-300 rounded-md bg-white dark:bg-gray-800 dark:border-gray-700 dark:text-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 px-3 h-10"
                                            wrapperClassName="w-full"
                                        /> {/* onChange={(date) => setStartDate(date)} */}
                                    </div>
                                </div>

                                <div className="w-full">
                                    <Label htmlFor="fecha actualizacion">Última actualización</Label>
                                    <div className="mt-1">
                                        <DatePicker
                                            disabled
                                            required
                                            dateFormat="dd/MM/yyyy"
                                            selected={fechaActualizacionAjustada || ""}//{datosGenerales.fecha_actualizacion || ""}
                                            //selected={fechaActualizacion}//usar el useMemo
                                            className="w-full border border-gray-300 rounded-md bg-white dark:bg-gray-800 dark:border-gray-700 dark:text-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 px-3 h-10"
                                            wrapperClassName="w-full"
                                            //onChange={(date) => setStartDate(date)}
                                            onChange={(date) => updateField('formA', 'datosGenerales', 'fecha_actualizacion', date)}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="px-2">
                                <Label htmlFor="encargado_proyecto">Encargado de Proyecto</Label>
                                <Select_simple
                                    options={optionsEncargadoProyecto}
                                    id="encargado_proyecto"
                                    name="encargado_proyecto"
                                    placeholder="Seleccionar..."
                                    value={datosGenerales.encargado_proyecto}
                                    onChange={e => handleInputChange(e)}
                                />
                                {!datosGenerales.encargado_proyecto && (
                                    <p className="text-sm text-red-600 mt-1">
                                        *⚠️ Campo obligatorio
                                    </p>
                                )}
                            </div>

                            <div className="px-2">
                                {nuevaONG && (
                                    <p>Se ha creado una nueva ONG: {nuevaONG.ong}</p>
                                )}
                                <SubsidioForm />

                            </div>

                            {/* POR AHORA SE VA
                            <div className="px-2">
                                <Label htmlFor="presidente_ong">Presidente ONG / Intendente</Label>
                                <Input
                                    id="presidente_ong"
                                    name="presidente_ong"
                                    type="text"
                                    placeholder="Presidente ONG / Intendente"
                                    value={presidente_ong || ''}
                                    onChange={e => onChange(e)}
                                />
                            </div>*/}

                            {/*vuelve 7nov 2025 REFERENTES por ahora se va 14-JUN-2025*/}
                            <div className="px-2">
                                {/*{nuevoReferente && (
                                    <p>Se ha creado un nuevo referente: {nuevoReferente.nombre}</p>
                                )}}*/}
                                <Label htmlFor="referente_politico_nombre">Referente</Label>
                                <Input
                                    id="referente_politico_nombre"
                                    name="referente_politico_nombre"
                                    type="text"
                                    placeholder="Referente"
                                    value={datosGenerales.referente_politico_nombre || ''}
                                    onChange={e => handleInputChange(e)}
                                />
                            </div>

                            {/* Componente Hijo: Contactos del Proyecto */}
                            <div className="px-2 mt-4 col-span-2">
                                <div className="p-4 border border-gray-200 dark:border-gray-700 rounded-lg bg-gray-50/50 dark:bg-gray-800/50 backdrop-blur-sm shadow-sm transition-all duration-300 hover:shadow-md">
                                    <h4 className="text-sm font-semibold text-gray-800 dark:text-gray-200 mb-3 flex items-center gap-2">
                                        Contactos del Proyecto
                                    </h4>

                                    {(() => {
                                        const tipoCanon = normalizarTipoSubsidio(datosGenerales?.tipo_subsidio);
                                        const esONG = esObraConONG(tipoCanon);
                                        const partido = (datosGenerales?.partido_nombre || '').trim();

                                        // ONG: catalogo de la ONG elegida.
                                        // Municipio/Universidad/Otro: catalogo del
                                        // tipo + partido de la obra.
                                        const scope = esONG
                                            ? (datosGenerales?.ongs_id
                                                ? { tipo: 'ong', ongId: datosGenerales.ongs_id }
                                                : null)
                                            : (tipoCanon && partido
                                                ? { tipo: 'partido', tipoSubsidio: tipoCanon, partido }
                                                : null);

                                        if (scope) {
                                            return (
                                                <ListaContactosProyecto
                                                    scope={scope}
                                                    contactos={contactosObra}
                                                    onChange={handleContactosChange}
                                                    permitirEdicion={false}
                                                    mensajeVacio="No hay contactos cargados para esta obra."
                                                    codigoObra={datosGenerales?.id_partido_obra || null}
                                                />
                                            );
                                        }
                                        if (esONG) {
                                            return (
                                                <p className="text-sm text-gray-500 italic">
                                                    Elegí una ONG arriba para ver sus contactos.
                                                </p>
                                            );
                                        }
                                        if (!tipoCanon) {
                                            return (
                                                <p className="text-sm text-gray-500 italic">
                                                    Elegí un tipo de subsidio para cargar contactos.
                                                </p>
                                            );
                                        }
                                        return (
                                            <p className="text-sm text-gray-500 italic">
                                                Elegí un partido arriba para ver los contactos de ese partido.
                                            </p>
                                        );
                                    })()}
                                </div>
                            </div>


                            <div className="px-2">
                                <Label htmlFor="area_responsable">Área responsable</Label>
                                <Select_simple
                                    id="area_responsable"
                                    options={optionsAreaResponsable}
                                    name="area_responsable"
                                    placeholder="Seleccionar..."
                                    value={datosGenerales.area_responsable}
                                    onChange={e => handleInputChange(e)}
                                    disabled={estadoAppX === 'nuevo_etapa2' || estadoAppX === 'edit_etapa2' || isSegundaEtapa}
                                />
                                {!datosGenerales.area_responsable && (
                                    <p className="text-sm text-red-600 mt-1">
                                        *⚠️ Campo obligatorio
                                    </p>
                                )}
                            </div>

                            {datosGenerales.area_responsable === AREA_RESP_OBRAS && (
                                <div className="px-2">
                                    <Label htmlFor="programa_lineamiento">Programa</Label>
                                    <Select_simple
                                        id="programa_lineamiento"
                                        options={optionsProgramaUNO}
                                        name="programa_lineamiento"
                                        value={datosGenerales.programa_lineamiento}
                                        onChange={e => handleInputChange(e)}
                                        placeholder="Seleccionar..."
                                    />
                                </div>
                            )}

                            {datosGenerales.area_responsable === AREA_RESP_MEJORAS && (
                                <div className="px-2">
                                    <Label htmlFor="programa_lineamiento">Programa</Label>
                                    <Select_simple
                                        id="programa_lineamiento"
                                        options={optionsProgramaDOS}
                                        name="programa_lineamiento"
                                        value={datosGenerales.programa_lineamiento}
                                        onChange={e => handleInputChange(e)}
                                        placeholder="Seleccionar..."
                                        disabled={isSegundaEtapa && datosGenerales.programa_lineamiento === "Mejoras Habitacionales Trabajar en la Casa"}
                                    />
                                </div>
                            )}

                            {datosGenerales.area_responsable === AREA_RESP_MICROCREDITOS && (
                                <div className="px-2">
                                    <Label htmlFor="programa_lineamiento">Programa</Label>
                                    <Select_simple
                                        id="programa_lineamiento"
                                        options={optionsProgramaTRES}
                                        name="programa_lineamiento"
                                        value={datosGenerales.programa_lineamiento}
                                        onChange={e => handleInputChange(e)}
                                        placeholder="Seleccionar..."
                                    />
                                </div>
                            )}

                            {datosGenerales.area_responsable === AREA_RESP_INTERVENCION_SOCIAL && (
                                <div className="px-2">
                                    <Label htmlFor="programa_lineamiento">Programa</Label>
                                    <Select_simple
                                        id="programa_lineamiento"
                                        options={optionsProgramaCUATRO}
                                        name="programa_lineamiento"
                                        value={datosGenerales.programa_lineamiento}
                                        onChange={e => handleInputChange(e)}
                                        placeholder="Seleccionar..."
                                    />
                                </div>
                            )}

                            {datosGenerales.area_responsable === AREA_RESP_CAPACITACIONES && (
                                <div className="px-2">
                                    <Label htmlFor="programa_lineamiento">Programa</Label>
                                    <Select_simple
                                        id="programa_lineamiento"
                                        options={optionsProgramaSEIS}
                                        name="programa_lineamiento"
                                        value={datosGenerales.programa_lineamiento}
                                        onChange={e => handleInputChange(e)}
                                        placeholder="Seleccionar..."
                                    />
                                </div>
                            )}

                            {datosGenerales.area_responsable === AREA_RESP_OTRA && (
                                <div className="px-2">
                                    <Label htmlFor="programa_lineamiento">Programa</Label>
                                    <Select_simple
                                        id="programa_lineamiento"
                                        options={optionsProgramaCINCO}
                                        name="programa_lineamiento"
                                        value={datosGenerales.programa_lineamiento}
                                        onChange={e => handleInputChange(e)}
                                        placeholder="Seleccionar..."
                                    />
                                </div>
                            )}

                            {(datosGenerales.area_responsable === null || datosGenerales.area_responsable === "") && (
                                <div className="px-2">
                                    <Label htmlFor="programa_lineamiento">Programa</Label>
                                    <Select_simple
                                        id="programa_lineamiento"
                                        options={[]}
                                        name="programa_lineamiento"
                                        value={datosGenerales.programa_lineamiento}
                                        onChange={e => handleInputChange(e)}
                                        //placeholder="Seleccionar..."
                                        disabled
                                    />
                                </div>
                            )}

                            {/* renderizado para programa opcion 1*/}
                            {datosGenerales.programa_lineamiento === "Financiamiento para la Mejora del Hábitat" && (//cambio 16abr2026 Mejora del Hábitat
                                <div className="px-2">
                                    <Label htmlFor="modalidad">Modalidad</Label>
                                    <Select_simple
                                        id="modalidad"
                                        name="modalidad"
                                        options={optionsModalidadUNO}
                                        placeholder="Seleccionar..."
                                        value={datosGenerales.modalidad}
                                        onChange={e => handleInputChange(e)}
                                    />
                                </div>
                            )}

                            {/* renderizado para programa opcion 2.- Mejoras Habitacionales “Trabajar en la Casa”*/}
                            {datosGenerales.programa_lineamiento === "Mejoras Habitacionales Trabajar en la Casa" && (
                                <div className="px-2">
                                    <Label htmlFor="modalidad">Modalidad</Label>
                                    <Select_simple
                                        id="modalidad"
                                        name="modalidad"
                                        options={isSegundaEtapa ? optionsModalidadDOS : [optionsModalidadDOS[0]]}
                                        placeholder="Seleccionar..."
                                        value={isSegundaEtapa ? (datosGenerales.modalidad || "etapa II") : (datosGenerales.modalidad || 'etapa I')}
                                        onChange={handleModalidadChange}
                                        disabled={true}
                                    />
                                </div>
                            )}

                            {/* renderizado para programa 4.- */}
                            {datosGenerales.programa_lineamiento === "Financiación para la Capacitación y Difusión de la Gestión del hábitat bonaerense" && (
                                <div className="px-2">
                                    <Label htmlFor="modalidad">Modalidad</Label>
                                    <Select_simple
                                        id="modalidad"
                                        name="modalidad"
                                        options={optionsModalidadCUATRO}
                                        placeholder="Seleccionar..."
                                        value={datosGenerales.modalidad}
                                        onChange={e => handleInputChange(e)}
                                    />
                                </div>
                            )
                            }

                            { //!['Fortalecimiento de Organizaciones de la Comunidad y Municipios para la producción del Hábitat', 'Financiamiento para la Mejora del Hábitat'].includes(datosGenerales.programa_lineamiento) 
                                (datosGenerales.programa_lineamiento === "" || datosGenerales.programa_lineamiento === null) && (
                                    <div className="px-2">
                                        <Label htmlFor="modalidad">Modalidad</Label>
                                        <select
                                            disabled
                                            className="w-full px-4 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:border-blue-500 dark:bg-gray-800 dark:text-white dark:border-gray-700"
                                            id="modalidad"
                                            name="modalidad"
                                            options=""
                                            onChange={e => handleInputChange(e)}
                                        />
                                        <span>{datosGenerales.area_responsable}</span>
                                    </div>
                                )
                            }

                            <div className="px-2">
                                <Label htmlFor="beneficiarios">Beneficiarios</Label>
                                <Input
                                    id="beneficiarios"
                                    name="beneficiarios"
                                    type="text"
                                    placeholder="Beneficiarios"
                                    value={datosGenerales.beneficiarios || ''}
                                    onChange={e => handleInputChange(e)}
                                />
                            </div>

                            <div className="flex flex-row">{/*un div para las dos fechas */}

                                <div className="w-1/2 px-2">
                                    <InputMontoObra
                                    //formattedValue={formattedValue}
                                    //numericValue={numericValue}
                                    //setFormattedValue={handleChangeFormattedValue}
                                    //setNumericValue={handleChangeNumericValue}
                                    />
                                </div>

                                <div className="w-1/2 px-2">
                                    <Label htmlFor="fecha_imputacion">Fecha de imputacion</Label>
                                    <DatePicker
                                        dateFormat="dd/MM/yyyy"
                                        selected={fechaImputacionAjustada || ""}//{_fecha_imputacion || ""}
                                        className="mt-1 block w-full border border-gray-300 rounded-md bg-white dark:bg-gray-800 dark:border-gray-700 dark:text-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 px-3 h-10"
                                        wrapperClassName="w-full"
                                        onChange={(date) => handleChangeDate({ name: "fecha_imputacion", value: date })}
                                    />
                                </div>
                            </div>

                            <div className="px-2">
                                <Label htmlFor="tipo_contratacion">Tipo contratación</Label> {/*15 */}
                                <Select_simple
                                    id="tipo_contratacion"
                                    options={optionsTipoContratacion}
                                    name="tipo_contratacion"
                                    //placeholder="Tipo contratación"
                                    value={datosGenerales.tipo_contratacion}
                                    onChange={e => handleInputChange(e)}
                                />
                            </div>

                            <div className="px-2">
                                <Label htmlFor="plazo_obra">Plazo de obra (días)</Label> {/*20*/}
                                <Input
                                    id="plazo_obra"
                                    name="plazo_obra"
                                    type="text"
                                    placeholder="Plazo de obra"
                                    value={datosGenerales.plazo_obra || ''}
                                    onChange={e => handleInputChange(e)}
                                />
                            </div>

                            <div className="px-2">
                                <Label htmlFor="estado">Estado del expediente</Label> {/*16 */}
                                <Select_simple
                                    id="estado"
                                    options={optionsEstadoFiltrado}
                                    name="estado"
                                    //placeholder="Estado"
                                    value={datosGenerales.estado}
                                    onChange={e => handleInputChange(e)}
                                    placeholder="Seleccionar..."
                                />
                                {(datosGenerales.estado === "" || datosGenerales.estado === undefined) && (
                                    <p className="text-sm text-red-600 mt-1">
                                        *⚠️ Campo obligatorio
                                    </p>
                                )}
                            </div>

                        </div>{/* cierra COLUMN UNO */}

                        <div className="space-y-4"> {/* COLUMNA DOS - para la otra mitad de DAtos generales*/}

                            <div className="space-y-4">
                                <div className="flex flex-row">
                                    <h2 className="text-xl font-bold mb-2">EXPEDIENTES</h2>
                                    <InfoButtonWithPopover infoText="EN TESTEO." />
                                </div>
                                <ExpedienteSubform disabled={datosGenerales.estado === ESTADO_CONFECCION_EXPEDIENTE} />
                            </div>

                            <h2 className="text-xl font-bold mb-2">LOCALIZACION</h2>

                            <div className="px-2">
                                <Label htmlFor="lc_21_localidad">
                                    Localidad
                                </Label>
                                <Input
                                    type="text"
                                    name="lc_21_localidad"
                                    value={datosGenerales.lc_21_localidad || ""}
                                    onChange={e => handleInputChange(e)}
                                    required
                                />
                            </div>

                            {datosGenerales.area_responsable !== AREA_RESP_MICROCREDITOS && (
                                <>
                                    <div className="px-2">
                                        <Label htmlFor="lc_22_identificacion_catastral">
                                            Identificación catastral
                                        </Label>
                                        <Select_simple
                                            name="lc_22_identificacion_catastral"
                                            value={datosGenerales.lc_22_identificacion_catastral}
                                            options={optionsIdentificacionCatastral}
                                            onChange={e => handleInputChange(e)}
                                        />
                                    </div>

                                    {datosGenerales.lc_22_identificacion_catastral === "SI" && (
                                        <>
                                            <div className="px-2">
                                                <Label htmlFor="lc_22_1_datos_catastrales">
                                                    Datos catastrales
                                                </Label>
                                                <Input
                                                    type="text"
                                                    name="lc_22_1_datos_catastrales"
                                                    value={datosGenerales.lc_22_1_datos_catastrales}
                                                    onChange={e => handleInputChange(e)}
                                                />
                                            </div>
                                            <div className="px-2">
                                                <Label htmlFor="lc_22_2_cuadro_calles" >
                                                    Cuadro de Calles
                                                </Label>
                                                <Input
                                                    type="text"
                                                    name="lc_22_2_cuadro_calles"
                                                    value={datosGenerales.lc_22_2_cuadro_calles}
                                                    onChange={e => handleInputChange(e)}
                                                />
                                            </div>
                                        </>
                                    )}

                                    {datosGenerales.lc_22_identificacion_catastral === "NO" && (
                                        <div className="px-2">
                                            <Label htmlFor="lc_22_2_cuadro_calles" >
                                                Cuadro de Calles
                                            </Label>
                                            <Input
                                                type="text"
                                                name="lc_22_2_cuadro_calles"
                                                value={datosGenerales.lc_22_2_cuadro_calles}
                                                onChange={e => handleInputChange(e)}
                                            />
                                        </div>
                                    )}

                                    <div className="px-2">
                                        <Label htmlFor="lc_24_titular_dominio">
                                            Titular de dominio
                                        </Label>
                                        <Input
                                            type="text"
                                            name="lc_24_titular_dominio"
                                            value={datosGenerales.lc_24_titular_dominio || ""}
                                            onChange={e => handleInputChange(e)}
                                        />
                                        <DominioPdfUpload
                                            codigoObra={datosGenerales.id_partido_obra}
                                            token={token}
                                            role={role}
                                            roles={roles}
                                        />
                                    </div>
                                </>
                            )}

                            <div className="px-2 mb-6">
                                <Label htmlFor="lc_23_observaciones_localizacion">
                                    Observaciones de Localización
                                </Label>
                                <p className="text-sm text-gray-500">
                                    **Consignar los folios de los barrios donde se interviene y cantidad de mejoras por barrio**
                                </p>
                                <textarea
                                    value={datosGenerales.lc_23_observaciones_localizacion || ''}
                                    maxLength="2000"
                                    name="lc_23_observaciones_localizacion"
                                    onChange={e => handleInputChange(e)}
                                    className="w-full px-4 py-2 text-sm border border-gray-300 rounded-md resize-none focus:outline-none focus:border-blue-500 dark:bg-gray-800 dark:text-white dark:border-gray-700 resize-y"
                                    rows="4"
                                    placeholder="Observaciones de localización"
                                />
                                <div>
                                    {/*<p align="right" style={{height: "5px", fontSize: "0.9em"}}>Caracteres restantes: {contadorCaracteresRestantes(2000, textInput2.length)}</p><br/>*/}
                                    <p align="right" className="text-sm text-gray-500" style={{ height: "5px", fontSize: "0.9em" }}>
                                        Caracteres restantes: {contadorCaracteresRestantes(2000, datosGenerales.lc_23_observaciones_localizacion)}
                                    </p>
                                </div>
                            </div>

                            <div className="mb-6 dark">
                                {datosGenerales.area_responsable === 'ÁREA DE PROYECTOS' && <Modal2
                                    partido={datosGenerales?.partido}
                                />}
                                {role === 'admin' && drawnFeatures.length > 0 && (
                                    <div className={`mb-6 p-4 border rounded ${isDarkMode ? 'border-gray-600 bg-gray-800' : 'border-gray-300 bg-white'}`}>
                                        <div className="flex justify-between items-center mb-2">
                                            <h3 className="font-bold text-lg">Datos del Mapa (Solo Admin)</h3>
                                            <button
                                                className="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
                                                title="Cerrar"
                                            >
                                                ×
                                            </button>
                                        </div>
                                        <div className="space-y-2">
                                            <div className="space-y-2">
                                                {drawnFeatures.map((feature, index) => (
                                                    <div key={index} className="text-sm text-gray-600 dark:text-gray-300">
                                                        <span className="font-medium">Feature {index + 1}:</span>
                                                        <div className="ml-4">
                                                            <div>
                                                                <span className="font-medium">ID:</span> {feature.id}
                                                            </div>
                                                            <div>
                                                                <span className="font-medium">WKT:</span> {feature.wkt?.substring(0, 50)}...
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                            <div className="mt-2">
                                                <details className="text-sm">
                                                    <summary className="cursor-pointer text-blue-500 hover:text-blue-700 dark:text-blue-400 dark:hover:text-blue-300">
                                                        Ver datos completos
                                                    </summary>
                                                    <pre className="mt-2 p-2 bg-gray-100 dark:bg-gray-700 rounded overflow-auto max-h-48 text-xs">
                                                        {JSON.stringify(drawnFeatures, null, 2)}
                                                    </pre>
                                                </details>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>

                            <div className="px-2">
                                <Label htmlFor="tiposBarrioSeleccionados">Barrio</Label>
                                <Select
                                    isMulti
                                    id="tiposBarrioSeleccionados"
                                    options={optionsBarrioTipoFiltrado}//optionsBarrioTipo
                                    value={tiposBarrioSeleccionados}
                                    onChange={(selected) => updateField('formA', 'tiposBarrioSeleccionados', null, selected || [])}
                                    placeholder="Seleccionar tipo(s) de barrio..."
                                    className="mt-1"
                                    styles={customSelectStyles}
                                    isDisabled={!datosGenerales.partido}
                                />
                                <p className="text-xs text-gray-500 mt-1">
                                    Seleccione uno o más tipos de barrio que correspondan al proyecto
                                </p>
                            </div>

                            {/* Sección RPPVAP - visible si está seleccionado */}
                            {tiposBarrioSeleccionados.some(t => t.value === 'RPPVAP') && (
                                <div className="px-2">
                                    <Label htmlFor="barrios_rppvap">Seleccionar Barrio(s) RPPVAP</Label>
                                    {puedeVerRENABAP && datosGenerales.barrio_rppvap_nombre && !barriosSeleccionados?.some(b => b.label?.includes(datosGenerales.barrio_rppvap_nombre)) && (
                                        <p className="text-xs text-orange-600 mt-1 font-semibold">
                                            ⚠️ Atención: No hubo matcheo con el barrio &quot;{datosGenerales.barrio_rppvap_nombre}&quot; del registro original
                                        </p>
                                    )}
                                    <Select
                                        isMulti
                                        options={(() => {
                                            // Crear opciones agrupadas por partido para react-select
                                            const partidoPrincipal = datosGenerales.partido;
                                            const grupos = {};

                                            // Agrupar barrios por partido
                                            Array.isArray(barriosRPPVAP) && barriosRPPVAP.forEach(b => {
                                                const partidoId = String(b.partido_nro);
                                                const esPrincipal = partidoId === String(partidoPrincipal);
                                                const nombrePartido = optionsPartido.find(p => String(p.value) === partidoId)?.label || `Partido ${partidoId}`;
                                                const key = esPrincipal ? `--- ${nombrePartido} (Principal) ---` : `--- ${nombrePartido} ---`;

                                                if (!grupos[key]) {
                                                    grupos[key] = [];
                                                }
                                                grupos[key].push({
                                                    value: b.codigo_folio,
                                                    label: `${b.codigo_folio} - ${b.nombre_del_barrio}`,
                                                    nombre_barrio: b.nombre_del_barrio
                                                });
                                            });

                                            // Ordenar grupos: primero el principal, luego alfabéticamente
                                            const keysOrdenadas = Object.keys(grupos).sort((a, b) => {
                                                const aEsPrincipal = a.includes('(Principal)');
                                                const bEsPrincipal = b.includes('(Principal)');
                                                if (aEsPrincipal && !bEsPrincipal) return -1;
                                                if (!aEsPrincipal && bEsPrincipal) return 1;
                                                return a.localeCompare(b);
                                            });

                                            // Convertir a formato groupedOptions de react-select
                                            const groupedOptions = keysOrdenadas.map(key => ({
                                                label: key,
                                                options: grupos[key]
                                            }));

                                            return groupedOptions;
                                        })()}
                                        value={barriosSeleccionados}
                                        onChange={(selected) => updateField('formA', 'barriosSeleccionados', null, selected || [])}
                                        placeholder="Seleccionar barrios..."
                                        className="mt-1"
                                        styles={customSelectStyles}
                                    />
                                    <p className="text-xs text-gray-500 mt-1">
                                        Seleccione todos los barrios donde se desarrolla el proyecto
                                    </p>
                                </div>
                            )}

                            {/* Sección RENABAP - visible si está seleccionado y usuario tiene permiso */}
                            {puedeVerRENABAP && tiposBarrioSeleccionados.some(t => t.value === 'RENABAP') && (
                                <div className="px-2">
                                    <Label htmlFor="barrios_renabap">Seleccionar Barrio(s) RENABAP</Label>
                                    <Select
                                        isMulti
                                        options={(() => {
                                            const partidoPrincipal = datosGenerales.partido;
                                            const grupos = {};

                                            Array.isArray(barriosRENABAP) && barriosRENABAP.forEach(b => {
                                                const partidoId = String(b.partido_nro);
                                                const esPrincipal = partidoId === String(partidoPrincipal);
                                                const nombrePartido = optionsPartido.find(p => String(p.value) === partidoId)?.label || `Partido ${partidoId}`;
                                                const localidadLabel = b.localidad || 'Sin localidad';
                                                const key = esPrincipal
                                                    ? `--- ${nombrePartido} (Principal) > ${localidadLabel} ---`
                                                    : `--- ${nombrePartido} > ${localidadLabel} ---`;

                                                if (!grupos[key]) {
                                                    grupos[key] = [];
                                                }
                                                grupos[key].push({
                                                    value: String(b.id_renabap),
                                                    label: `${b.nombre_bar} (${b.id_renabap})`,
                                                    nombre_barrio: b.nombre_bar,
                                                    localidad: b.localidad,
                                                    id_renabap: b.id_renabap
                                                });
                                            });

                                            const keysOrdenadas = Object.keys(grupos).sort((a, b) => {
                                                const aEsPrincipal = a.includes('(Principal)');
                                                const bEsPrincipal = b.includes('(Principal)');
                                                if (aEsPrincipal && !bEsPrincipal) return -1;
                                                if (!aEsPrincipal && bEsPrincipal) return 1;
                                                return a.localeCompare(b);
                                            });

                                            const groupedOptions = keysOrdenadas.map(key => ({
                                                label: key,
                                                options: grupos[key]
                                            }));

                                            return groupedOptions;
                                        })()}

                                        value={barriosRENABAPSeleccionados}
                                        onChange={(selected) => updateField('formA', 'barriosRENABAPSeleccionados', null, selected || [])}
                                        placeholder="Seleccionar barrios RENABAP..."
                                        className="mt-1"
                                        styles={customSelectStyles}
                                    />
                                    <p className="text-xs text-gray-500 mt-1">
                                        Seleccione todos los barrios RENABAP donde se desarrolla el proyecto
                                    </p>
                                </div>
                            )}

                            {/* Sección OTRO - visible si está seleccionado */}
                            {tiposBarrioSeleccionados.some(t => t.value === 'OTRO') && (
                                <div className="px-2">
                                    {/* Input legacy: visible para todos 
                                    <div className="mb-3">
                                        <Label htmlFor="barrio_otro_nombre">
                                            Nombre del Barrio
                                            {role !== 'admin' && <InfoButtonWithPopover infoText="No disponible temporalmente" />}
                                        </Label>
                                        <Input
                                            type="text"
                                            name="barrio_otro_nombre"
                                            value={datosGenerales.barrio_otro_nombre}
                                            onChange={(e) => { handleInputChange(e) }}
                                            disabled={role !== 'admin'}
                                            maxLength={100}
                                        />

                                    </div>*/}
                                    {/* Input multi-nombre tipo tags: solo admin */}
                                    <div>
                                        <Label>Nombres múltiples del Barrio</Label>
                                        <div className="w-full px-4 py-2 text-sm border border-gray-300 rounded-md focus-within:border-blue-500 dark:bg-gray-800 dark:text-white dark:border-gray-700 flex flex-wrap gap-1 cursor-text min-h-[42px]"
                                            onClick={() => {
                                                const input = document.getElementById('tag-input-otro');
                                                if (input) input.focus();
                                            }}
                                        >
                                            {(barrioOtroNombres || []).map((nombre, i) => (
                                                <span key={i} className="inline-flex items-center gap-1 bg-blue-100 text-blue-800 text-sm px-2 py-0.5 rounded max-w-full break-all">
                                                    {nombre}
                                                    <button
                                                        type="button"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            const nuevos = barrioOtroNombres.filter((_, j) => j !== i);
                                                            updateField('formA', 'barrioOtroNombres', null, nuevos);
                                                        }}
                                                        className="text-blue-600 hover:text-blue-900 font-bold leading-none text-base"
                                                    >
                                                        ×
                                                    </button>
                                                </span>
                                            ))}
                                            <input
                                                id="tag-input-otro"
                                                type="text"
                                                placeholder={barrioOtroNombres?.length ? '' : 'Escribir nombre y presionar Enter...'}
                                                className="flex-1 min-w-[120px] outline-none border-none bg-transparent text-sm dark:text-white p-0 m-0"
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        e.preventDefault();
                                                        const val = e.target.value.trim();
                                                        if (val) {
                                                            updateField('formA', 'barrioOtroNombres', null, [...(barrioOtroNombres || []), val]);
                                                        }
                                                        e.target.value = '';
                                                    } else if (e.key === 'Backspace' && !e.target.value && barrioOtroNombres?.length) {
                                                        const nuevos = barrioOtroNombres.slice(0, -1);
                                                        updateField('formA', 'barrioOtroNombres', null, nuevos);
                                                    }
                                                }}
                                                maxLength={100}
                                            />
                                        </div>
                                        <p className="text-sm text-gray-500 mt-1">
                                            Enter para agregar, Backspace para borrar, click en × para remover.
                                        </p>
                                    </div>
                                </div>
                            )}
                        </div> {/* cierra COLUMN DOS */}

                    </div>
                </form>
            </div>

            <div className="p-4 bg-white dark:bg-gray-900 h-auto">
                <div className="space-y-2" >{/* aca no hace falta que se a form*/}
                    {/*<div className="bg-blue-300 dark:bg-gray-700 h-8 py-2">Prueba Tipo y subtipo</div>*/}


                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

                        {/* COLUMNA UNO*/}
                        <div className="space-y-4 h-auto">
                            <h2 className="text-xl font-bold mb-2">TIPO Y SUBTIPO DE PROYECTO</h2>
                            <TipoProyectoSubform />
                            {/*<TipoProyectoSubform
                                
                                //onDataFromNieto={onDataFromNieto} //25JUL2025: NO usar - se quitó

                                onDataChangeSub={onDataChangeSub} //25JUL2025: pasar rows desde TipoProyectoSubform
                                arrayTipoSubtipoProyecto={datosGenerales.array_tipo_subtipo_proyecto} //NOTA 26JUL2025: pasamo al Sumformulario el array de Tipo y Subtipo Proyecto
                            />*/}

                            <div className="px-2">
                                <Label htmlFor="descripcion_proyecto">Descripcion del proyecto</Label>
                                <textarea
                                    value={datosGenerales.descripcion_proyecto || ''}
                                    maxLength="2000"
                                    name="descripcion_proyecto"
                                    onChange={e => handleInputChange(e)}
                                    className="w-full px-4 py-2 text-sm border border-gray-300 rounded-md resize-none focus:outline-none focus:border-blue-500 dark:bg-gray-800 dark:text-white dark:border-gray-700 resize-y"
                                    rows="4"
                                    placeholder="Descripcion del proyecto"
                                />
                                <div>
                                    {/*<p align="right" className="text-sm text-gray-500" style={{height: "5px", fontSize: "0.9em"}}>Caracteres restantes: {contadorCaracteresRestantes(2000, textInput1.length)}</p>*/}
                                    <p align="right" className="text-sm text-gray-500" style={{ height: "5px", fontSize: "0.9em" }}>
                                        Caracteres restantes: {contadorCaracteresRestantes(2000, datosGenerales.descripcion_proyecto)}
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* COLUMNA DOS*/}

                    </div>
                </div>
            </div>

            {/* Modal de cambio de partido (crítico: recalcula el ID de la obra) */}
            <Modal
                isOpen={cambiarPartidoOpen}
                onClose={() => setCambiarPartidoOpen(false)}
                title={`Cambiar partido — ${datosGenerales.id_partido_obra || ''}`}
                maxWidth="max-w-xl"
            >
                <div className="space-y-4">
                    <div className="text-sm text-gray-700 dark:text-gray-300 space-y-2">
                        <p>
                            Proyecto: <strong>{datosGenerales.nombre_obra || ''}</strong>
                            {partidoActualLabel && (
                                <span className="ml-2 text-xs text-gray-500">({partidoActualLabel})</span>
                            )}
                        </p>
                        <p>
                            Esta operación <strong>crea un proyecto idéntico en el partido destino</strong> con un nuevo
                            ID (calculado como un proyecto nuevo) y <strong>da de baja (soft delete) la obra actual</strong>,
                            conservando su código.
                        </p>
                        <ul className="list-disc pl-5 text-xs space-y-1">
                            <li>Solo permitido en estado <strong>Análisis preliminar</strong>.</li>
                            <li>Bloqueado si el Área de Mejoras ya tiene <strong>Etapa II</strong> asociada.</li>
                            <li>Bloqueado si tiene <strong>barrios RENABAP / RPPVAP</strong> cargados.</li>
                            <li>Bloqueado si tiene <strong>localización</strong> (geometría en el mapa o datos catastrales).</li>
                            <li>Bloqueado si el partido destino ya está dentro de <strong>Partidos adicionales</strong>.</li>
                        </ul>
                    </div>

                    <div>
                        <Label htmlFor="cambiar_partido_destino">Nuevo partido</Label>
                        <Select_simple
                            id="cambiar_partido_destino"
                            options={[
                                { value: '', label: 'Seleccionar partido...' },
                                ...optionsPartido
                                    .filter(o => String(o.value) !== String(datosGenerales.partido ?? ''))
                                    .map(o => ({ value: o.value, label: `${o.label} (${o.value})` })),
                            ]}
                            value={cambiarPartidoTarget}
                            onChange={e => setCambiarPartidoTarget(e.target.value)}
                        />
                    </div>

                    {cambiarPartidoMsg && (
                        <div className={`px-3 py-2 rounded-md text-sm border ${
                            cambiarPartidoMsg.tipo === 'ok'
                                ? 'bg-green-50 text-green-800 border-green-300 dark:bg-green-900/30 dark:text-green-300'
                                : 'bg-red-50 text-red-800 border-red-300 dark:bg-red-900/30 dark:text-red-300'
                        }`}>
                            {cambiarPartidoMsg.texto}
                        </div>
                    )}

                    <div className="flex gap-3 justify-end">
                        <button
                            type="button"
                            onClick={() => setCambiarPartidoOpen(false)}
                            disabled={cambiarPartidoLoading || cambiarPartidoOk}
                            className="px-4 py-2 rounded-md border border-gray-300 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors disabled:opacity-50"
                        >
                            Cancelar
                        </button>
                        <button
                            type="button"
                            onClick={confirmarCambioPartido}
                            disabled={!cambiarPartidoTarget || cambiarPartidoLoading || cambiarPartidoOk}
                            className="px-4 py-2 rounded-md bg-amber-500 text-white hover:bg-amber-600 transition-colors disabled:bg-gray-300 disabled:text-gray-500 disabled:cursor-not-allowed"
                        >
                            {cambiarPartidoLoading ? 'Procesando...' : 'Confirmar y cambiar'}
                        </button>
                    </div>
                </div>
            </Modal>

        </>
    )
}

export default memo(FormA);
